import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../../shared/_utils/services/base-service';
import { SpinnerService } from './spinner.service';
import { FundingPhase } from '../entities/funding-phase';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { tap } from 'rxjs/operators';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';

interface ExtraSearchFields {
    startDateRange01?: Date,
    startDateRange02?: Date,
    firstDocumentNumber?: string,
    latestDocumentNumber?: string
}

@Injectable()
export class FundingPhaseService extends BaseCrudService<FundingPhase> {

    uri = '/api/fundingPhase/';

    constructor(injector: Injector, spinnerService: SpinnerService) {
        super(injector);
        // console.log('Instance fundingPhaseService');
    }

    buildSentence(entity?: FundingPhase, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
        if (entity || extraSearchFields) {
            let query = '';

            if (entity.fundingMain) {
                // console.log('fundingMain');
                // console.log(entity);
                if (entity.fundingMain.id) {
                    // console.log('fundingMain,id');
                    query = query.concat(
                        `fundingMain.id${QueryOperator.Equal}${entity.fundingMain.id}${QueryOperator.Split}`
                    );
                }
                if (entity.fundingMain.fiscalYear) {
                    query = query.concat(
                        `fundingMain.fiscalYear.id${QueryOperator.Equal}${entity.fundingMain.fiscalYear.id}${QueryOperator.Split}`
                    );
                }
                if (entity.fundingMain.executingUnit) {
                    query = query.concat(
                        `fundingMain.executingUnit.id${QueryOperator.Equal}${entity.fundingMain.executingUnit.id}${QueryOperator.Split}`
                    );
                }
                if (entity.fundingMain.voucherMaster) {
                    if (entity.fundingMain.voucherMaster.sequentialNumber) {
                        query = query.concat(
                            `fundingMain.voucherMaster.sequentialNumber${QueryOperator.Contain}${entity.fundingMain.voucherMaster.sequentialNumber}${QueryOperator.Split}`
                        );
                    }
                }
                if (entity.fundingMain.code) {
                    query = query.concat(
                        `fundingMain.code${QueryOperator.Contain}${entity.fundingMain.code}${QueryOperator.Split}`
                    );
                }
            }

            query = query.concat(
                entity && entity.identifier ?
                    `identifier.id${QueryOperator.Equal}${entity.identifier.id}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                entity && entity.vendor ?
                    `vendor.id${QueryOperator.Equal}${entity.vendor.id}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                entity && entity.employee ?
                    `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                entity && entity.documentType ?
                    `documentType.id${QueryOperator.Equal}${entity.documentType.id}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                entity && entity.documentNumber ?
                    `documentNumber${QueryOperator.Equal}${entity.documentNumber}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                extraSearchFields && extraSearchFields.startDateRange01 && extraSearchFields.startDateRange02 ?
                    // tslint:disable-next-line:max-line-length
                    `documentDate${QueryOperator.Between}${extraSearchFields.startDateRange01.toISOString()}${QueryOperator.Slash}${extraSearchFields.startDateRange02.toISOString()}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                extraSearchFields && extraSearchFields.firstDocumentNumber && extraSearchFields.latestDocumentNumber ?
                    // tslint:disable-next-line:max-line-length
                    `documentNumber${QueryOperator.Between}${extraSearchFields.firstDocumentNumber}${QueryOperator.Slash}${extraSearchFields.latestDocumentNumber}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            //console.log(query);
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }

        this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'id');
        return this.httpParams;
    }

    search2(entity?: FundingPhase, event?: LazyLoadEvent,
        extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<FundingPhase>> {

        const url = `${this.rutaServidor}${this.uri}search2`;
        this.spinnerService.showAll();
        const httpParams = this.buildSentence(entity, event, extraSearchFields);
        return this.httpClient.get<ResponsePageable<FundingPhase>>(url, { params: httpParams })
            .pipe(
                tap(response => {
                    if (response.numberOfElements > 0) {
                        response.content.forEach((value) => {
                            // debugger;
                            this.convertToDate(value);
                        })
                    }
                    //console.log('response search check here');
                    //console.log(response);
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }

    // getValidateAmountVoucherLedger(voucherMain : VoucherMain ,id :number): Observable<any> {

    //     const url = `${this.rutaServidor}${this.uri}getValidateAmountVoucherLedger/${id}`;  
    //         return this.httpClient.post<any>(url,voucherMain); 
    //   }

    insert2(entity: FundingPhase, phase: string): Observable<FundingPhase> {
        // const url = this.rutaServidor + this.uri;
        const url = `${this.rutaServidor}${this.uri}create2/${phase}`;
        return this.httpClient.post<FundingPhase>(url, entity)
            .pipe(
                tap(response => {
                    // debugger;
                    this.convertToDate(response);
                    this.spinnerService.hideAll();
                    //console.log(response);
                })
            );
    }

    insertPhase(entity: FundingPhase, phase: string, id : number): Observable<FundingPhase> {
        // const url = this.rutaServidor + this.uri;
        const url = `${this.rutaServidor}${this.uri}createPhase/${phase}/${id}`;
        return this.httpClient.post<FundingPhase>(url, entity)
            .pipe(
                tap(response => {
                    // debugger;
                    this.convertToDate(response);
                    this.spinnerService.hideAll();
                    //console.log(response);
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/funding-phase.service.ts